import { html } from 'lit';
import { TemplateResult } from 'lit';
import { ColumnDetails } from '../../../../grid/types/common';
import { Column, ColumnKeys } from '../types';
import { DeployerGridRowData } from '../types/deployer-grid-row-data';

export function renderDeployerRelayName(
  rowData: DeployerGridRowData,
  columnDetails: ColumnDetails<Column, ColumnKeys>
): TemplateResult {
  let deployerRelayName = rowData.item[columnDetails.key];

  deployerRelayName = this.handleDefaultColumnValue(deployerRelayName);

  return html`<span class="cell-label" style="cursor: pointer">${deployerRelayName}</span>`;
}

export function renderDeployerRelayIp(
  rowData: DeployerGridRowData,
  columnDetails: ColumnDetails<Column, ColumnKeys>
): TemplateResult {
  let deployerRelayIp = rowData.item[columnDetails.key];

  deployerRelayIp = this.handleDefaultColumnValue(deployerRelayIp);

  return html`<span class="cell-label">${deployerRelayIp}</span>`;
}

export function renderDeployerRelayLabel(rowData: DeployerGridRowData): TemplateResult {
  let deployerRelayLabel = rowData?.item?.specifics?.label;

  deployerRelayLabel = this.handleDefaultColumnValue(deployerRelayLabel);

  return html`<span class="cell-label">${deployerRelayLabel}</span>`;
}
